import React from 'react';

const Header = () => {
  return (
    <section id="header" className='max-w-7xl mx-auto'>
      {/* Page content */}
      <div>
        {/* Date */}
        <div className="p-10 text-right text-xl font-light font-sans" id="dateContainer">
          January 17, 2025
        </div>
        <div className='flex flex-col justify-center items-center gap-4 pb-4'>

        {/* Green check mark */}
        <img
          src="https://sinoclear.net/order-confirmation/assets/check-mark.png"
          alt="green check mark"
          className="w-14"
          loading="lazy"
        />

        {/* Thank you message */}
        <h4 className="text-center text-[#132c4d] text-4xl font-bold ">
          THANK YOU FOR YOUR ORDER
        </h4>
        </div>

      </div>
    </section>
  );
};

export default Header;
